<template lang="html">
    <div>
        <form @submit.prevent="addGaView">
            <div class="form-group">
                <label for="account">Account</label>
                <select class="form-control" name="account" v-model="form.account_id" @change="getProperties()">
                    <option :value="null">Select an Account</option>
                    <option v-for="account in accounts" :value="account.id">{{account.name}}</option>
                </select>
            </div>
            <div class="form-group" v-show="this.properties.length > 0">
                <label for="property">Property</label>
                <select class="form-control" name="property" v-model="form.property_id" @change="getViews()">
                    <option :value="null">Select a Property</option>
                    <option v-for="property in properties" :value="property.id">{{property.name}}</option>
                </select>
            </div>
            <div class="form-group" v-show="this.views.length > 0">
                <label for="view">View</label>
                <select class="form-control" name="view" v-model="form.view_id">
                    <option :value="null">Select a View</option>
                    <option v-for="view in views" :value="view.id">{{view.name}}</option>
                </select>
            </div>
            <div class="form-group" v-show="this.views.length > 0">
                <label for="view_label">View Label</label>
                <input class="form-control" type="text" name="view_label" v-model="form.view_label" placeholder="Optional">
            </div>
            <div class="form-group" v-show="this.form.view_id !== null">
                <button type="submit" class="btn btn-primary" :class="{'btn-loading': loading}" :disabled="loading">
                    Add View
                </button>
            </div>
        </form>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            accounts: [],

            properties: [],

            views: [],

            form: {
                account_id: null,
                property_id: null,
                view_id: null,
                client_name: null,
                view_name: null,
                ecommerce: false,
                monitor: 1,
            },

            loading: false
        }
    },

    computed: {
        ...mapGetters('client',{
            'client': 'activeClient',
            'isAdmin': 'isAdmin',
        }),
    },

    mounted() {
        this.getAccounts();
    },

    methods: {
        getAccounts() {
            axios.get('/api/ga/manager/accounts')
            .then((response) => {
                this.accounts = response.data;
            }).catch((error) => {
                console.log(error);
            });
        },

        getProperties() {
            this.views = [];
            this.form.property = null;
            this.form.view = null;
            axios.get(`/api/ga/manager/properties?account=${this.form.account_id}`)
            .then((response) => {
                this.properties = response.data;
            }).catch((error) => {
                console.log(error);
            });
        },

        getViews() {
            this.views = [];
            this.form.view = null;
            axios.get(`/api/ga/manager/views?account=${this.form.account_id}&property=${this.form.property_id}`)
            .then((response) => {
                this.views = response.data;
            }).catch((error) => {
                console.log(error);
            });
        },

        addGaView() {
            this.loading = true;
            this.form.client_name = this.client.name;
            this.form.view_name = this.getViewName();
            this.form.ecommerce = this.getViewEcommerce();
            let view = this.form;

            this.$store.dispatch('client/addGaView', {
                view: view
            })
            .then((response) => {
                Bus.$emit('show-success-alert', response.message);
                Bus.$emit('ga-view-added');
                this.reset();
                this.loading = false;
            }).catch((error) => {
                console.log(error.data);
                this.loading = false;
            });

        },

        getViewName() {
            return this.views.filter((v) => v.id === this.form.view_id)[0].name;
        },

        getViewEcommerce() {
            return this.views.filter((v) => v.id === this.form.view_id)[0].ecommerce;
        },

        reset() {
            this.properties = [];
            this.views = [];

            this.form = {
                account_id: null,
                property_id: null,
                view_id: null,
                client_name: null,
                view_name: null,
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/clients/NewGaViewForm.vue